import { MFM_EVENT_ALIAS } from "@/utils/mfm"

export const VK_APP_ENABLED = true

export const VK_APP_STATES: string[] = [
  "approved",
  "confirmedPaidByDirectorate",
  "confirmedPaidByRegion",
  "confirmedWithoutCompensation",
  "confirmedWithoutServices",
]

export const VK_APP_STATUSES: string[] = [
  "participant",
  "participantEscort",
  "volunteer",
  "attache",
]

export function isVkAppAllowed (
  eventAlias?: string | null,
  state?: string | null,
  statusAlias?: string | null,
): boolean {
  return VK_APP_ENABLED &&
    eventAlias === MFM_EVENT_ALIAS &&
    VK_APP_STATES.includes(state || "") &&
    VK_APP_STATUSES.includes(statusAlias || "")
}
